module.exports = __webpack_public_path__ + "img/hero-root.42d4e82.svg";